import Component from '../../shared/component';

export default class HoverableElement extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.displayElement();
  }

  displayElement() {
    if ('ontouchstart' in document) {
      this.$element.css('visibility', 'visible');
    }
  }
}
